import { isDefined } from "@ls/js-utils";
import SummaryType from "state/selections/Constants/SummaryType";

export default class PerfReturnDefinition {
  static getDefault = () =>
    new PerfReturnDefinition({
      type: "TOTAL_RETURN_CURRENT_DAY",
      summary: SummaryType.ABSOLUTE,
    });

  #type;
  #summary;
  #netGross;

  constructor({ type, summary, netGross }) {
    this.#type = type;
    this.#summary = summary;
    this.#netGross = netGross ?? "G";
  }

  get type() {
    return this.#type;
  }
  get summary() {
    return this.#summary;
  }
  get netGross() {
    return this.#netGross;
  }

  get key() {
    return `PerfReturn - ${this.type}, ${this.netGross}, ${this.summary}`;
  }

  get complete() {
    return isDefined(this.type);
  }

  setType = (value) =>
    new PerfReturnDefinition({
      ...this.copy(),
      type: value,
    });

  setSummary = (value) =>
    new PerfReturnDefinition({
      ...this.copy(),
      summary: value,
    });

  copy = () => {
    return {
      type: this.type,
      summary: this.summary,
      netGross: this.netGross,
    };
  };
}
